// extracted by mini-css-extract-plugin
export default {"boton":"ReaccionListaInvitadoScreen_boton__fXIrf","containerTable":"ReaccionListaInvitadoScreen_containerTable__pxAZh","subtitulo":"ReaccionListaInvitadoScreen_subtitulo__nm6jn"};